/** Textes « depenses » — le français fait foi. */
export const depenses = {
  titre: 'Dépenses',
  sousTitre: (devise: string) => `Une caisse à part pour les petites sorties · total en ${devise}`,
  enregistrerDepense: 'Enregistrer une dépense',
  debutCaisse: 'Début de caisse',
  rendreCaisse: 'Rendre à la caisse',
  vide: {
    titre: 'La caisse des dépenses est vide',
    texte: 'Plus rien à dépenser. Le gérant · finances doit y poser un début de caisse avant la prochaine sortie.',
  },
  kpi: {
    reste: 'Reste en caisse', resteDetail: 'ce qui peut encore être dépensé',
    pose: 'Posé ce mois',
    poseDontAilleurs: (m: string) => `dont ${m} venus d'ailleurs`,
    poseAilleurs: 'venu d\'ailleurs, pas de la caisse',
    poseCaisse: 'venu de la caisse principale',
    depense: 'Dépensé ce mois',
    depenseConsomme: (pct: number) => `${pct} % du fonds consommé`,
    depenseAucunFonds: 'aucun fonds posé ce mois-ci',
    rendu: 'Rendu à la caisse', renduDetail: 'ce qui est reparti au comptoir',
  },
  quiADepense: 'Qui a dépensé quoi',
  colonnesPersonnes: { personne: 'Personne', operations: 'Opérations', depense: 'Dépensé' },
  depensesDe: (mois: string) => `Les dépenses de ${mois}`,
  aucunMouvement: 'Aucun mouvement ce mois-ci',
  colonnes: { date: 'Date', type: 'Type', achat: 'Ce qui a été acheté', par: 'Par', montant: 'Montant' },
  piece: (p: string) => `pièce ${p}`,
  note: 'Un fonds pris sur la caisse principale y laisse sa trace : il apparaît dans son bilan du mois comme sorti. Un fonds venu d\'ailleurs ne la touche pas — c\'est à vous de dire d\'où vient le billet. Dans les deux cas, le solde du comptoir n\'est plus brouillé par l\'eau et le café.',
  saisieDepense: {
    aide: 'Dites ce qui a été acheté. La dépense sort de la caisse des dépenses, pas du comptoir.',
    bouton: 'Enregistrer la dépense',
  },
  saisieFonds: {
    aideCaisse: 'Ce montant quitte la caisse principale et entre dans la caisse des dépenses. Deux lignes liées : la caisse principale en garde la trace.',
    aideAilleurs: 'Cet argent vient d\'ailleurs — votre poche, un retrait déjà compté autre part. La caisse principale n\'est pas débitée.',
    bouton: 'Poser le fonds',
    libelleDefaut: (mois: string) => `Début de caisse — ${mois}`,
    dOu: 'D\'où vient cet argent',
    deCaisse: 'De la caisse principale',
    dAilleurs: 'D\'ailleurs',
    noteCaisse: 'La caisse principale sera débitée d\'autant, et le montant apparaîtra dans son bilan du mois comme sorti.',
    noteAilleurs: 'La caisse principale ne bougera pas. À choisir quand le billet ne vient pas du comptoir — sinon vous feriez disparaître de l\'argent qui n\'en est jamais sorti.',
  },
  saisieRendre: {
    titre: 'Rendre à la caisse principale',
    aide: 'Ce qui n\'a pas été dépensé retourne au comptoir. Deux lignes liées, comme à l\'aller.',
    bouton: 'Rendre au comptoir',
    libelleDefaut: 'Retour à la caisse principale',
  },
  saisie: {
    enregistre: (titre: string, m: string) => `${titre} — ${m} enregistré.`,
    echec: 'L\'enregistrement a échoué.',
    montant: (devise: string) => `Montant (${devise})`,
    libelle: 'Libellé',
    libelleExemple: 'Ex. : eau et café pour le comptoir',
    piece: 'Pièce justificative',
    pieceAide: 'Numéro de ticket, s\'il y en a un.',
  },
};
